module.exports = __webpack_public_path__ + "static/media/LP-Hero.28e7f2c3.png";